/* More Designs carousel: progress bar + keep selected phone model when opening another design */
if (!customElements.get('more-designs')) {
  customElements.define(
    'more-designs',
    class MoreDesigns extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-md-track]');
        this.bar = this.querySelector('[data-md-progress]');
        this.variantTitle = this.dataset.currentVariantTitle || '';
        this.initialTitle = this.variantTitle;

        if (this.track && this.bar) {
          this.onScroll = this.updateProgress.bind(this);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          this.updateProgress();
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event && event.data && event.data.variant;
            if (variant && variant.title) this.variantTitle = variant.title;
          });
        }

        this.addEventListener('click', this.onClick.bind(this));
      }

      disconnectedCallback() {
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        if (this.onScroll) window.removeEventListener('resize', this.onScroll);
        if (this.unsubscribe) this.unsubscribe();
      }

      updateProgress() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const visible = this.track.clientWidth / this.track.scrollWidth;
        const width = Math.max(visible, 0.1) * 100;
        this.bar.style.width = `${width}%`;
        const ratio = max > 0 ? this.track.scrollLeft / max : 0;
        const travel = (100 / width - 1) * 100;
        this.bar.style.transform = `translateX(${ratio * travel}%)`;
        this.querySelector('.more-designs__progress').hidden = max <= 0;
      }

      currentTitle() {
        const scope = this.closest('product-info') || document;
        const picker = scope.querySelector('variant-selects');
        if (!picker) return '';
        const values = [];
        picker.querySelectorAll('select').forEach((select) => values.push(select.value));
        picker.querySelectorAll('fieldset').forEach((fieldset) => {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (checked) values.push(checked.value);
        });
        return values.join(' / ');
      }

      async onClick(event) {
        const link = event.target.closest('a.more-designs__item');
        if (!link || link.hasAttribute('aria-current')) return;
        // Read the model at click time: right after a model change the page update
        // (and the variantChange event) can still be on its way
        const title = this.currentTitle() || this.variantTitle;
        // Server-rendered link already matches the model the page was loaded with
        if (!title || title === this.initialTitle) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;

        event.preventDefault();
        const handle = link.dataset.mdHandle;
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          const response = await fetch(`${root}products/${handle}.js`);
          const product = await response.json();
          const match = product.variants.find((v) => v.title === title);
          const base = link.href.split('?')[0];
          window.location.href = match ? `${base}?variant=${match.id}` : base;
        } catch (e) {
          window.location.href = link.href;
        }
      }
    }
  );
}